import four from '../assets/four.svg';
import one from '../assets/one.svg';
import send_icon_purple from '../assets/send_icon_purple.svg';
import three from '../assets/three.svg';
import two from '../assets/two.svg';
import './NossasAcoes.css';

const NossasAcoesDescription = [
  {
    title: 'Nossas ações',
    text: 'Para cumprirmos nossa missão, realizmos diversas ações dentro do Centro de Informática.'
  }
]

const NossasAcoesInfo = [
  {
    "description": "Realização de palestras e debates para os estudantes do CIn",
    "text": "Palestras e debates",
    "image": one
  },
  {

    "description": "Oferta de minicursos para a academia e comunidade",
    "text": "Minicursos",
    "image": two
  },
  {

    "description": "Realização de calouradas e eventos externos",
    "text": "Calouradas",
    "image": three
  },
  {

    "description": "O DACIn representa os alunos em diversos aspectos dentro e fora do CIn",
    "text": "Representação",
    "image": four
  }
];

function NossasAcoes() {
  return (
    <div id="NossasAcoes">
      <div className="CardPosition">
        <div className="CardAcoes">
          <div className="CardLine"></div>
          <h1>{NossasAcoesDescription[0]?.title}</h1>
          <p>{NossasAcoesDescription[0]?.text}</p>
        </div>
      </div>
        <div className="NossasAcoesInfo">
          <div className="Info1">
            <img src={NossasAcoesInfo[0]?.image} alt="picture_1" />
            <div className="AcoesContent1">
              <h1>{NossasAcoesInfo[0]?.text}</h1>
              <div className="NossasAcoesLine"></div>
              <p>{NossasAcoesInfo[0]?.description}</p>
            </div>
          </div>

          <div className="Info2">
            <img src={NossasAcoesInfo[1]?.image} alt="picture_2" />
            <div className="AcoesContent2">
              <h1>{NossasAcoesInfo[1]?.text}</h1>
              <div className="NossasAcoesLine"></div>
              <p>{NossasAcoesInfo[1]?.description}</p>
            </div>
          </div>

          <div className="Info3">
            <img src={NossasAcoesInfo[2]?.image} alt="picture_3" />
            <div className="AcoesContent3">
              <h1>{NossasAcoesInfo[2]?.text}</h1>
              <div className="NossasAcoesLine"></div>
              <p>{NossasAcoesInfo[2]?.description}</p>
            </div>
          </div>

          <div className="Info4">
            <img src={NossasAcoesInfo[3]?.image} alt="picture_4" />
            <div className="AcoesContent4">
              <h1>{NossasAcoesInfo[3]?.text}</h1>
              <div className="NossasAcoesLine"></div>
              <p>{NossasAcoesInfo[3]?.description}</p>
            </div>
          </div>
        </div>

        <div className="ButtonAcoes">
          <a href={'https://da.cin.ufpe.br/blog/index.html'} rel="noreferrer" target="_blank">
            <button className="BlogButton">
              <span>Acesse nosso blog</span>
              <img src={send_icon_purple} alt="send_icon_purple" />
            </button>
          </a>
        </div>
    </div>
  );
}

export default NossasAcoes;